import * as React from 'react';
import { Icon, IconProps } from '../Icon';

export const Fail: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 14 14" {...props}>
    <path d="M7 0a7 7 0 110 14A7 7 0 017 0zM3.898 3.062a.628.628 0 00-.716 1.01L6.112 7 3.183 9.93l-.073.087a.628.628 0 00.96.8l2.928-2.928 2.93 2.928.087.073a.628.628 0 00.8-.96L7.886 7l2.93-2.929.072-.087a.628.628 0 00-.96-.8l-2.93 2.93-2.927-2.93-.087-.073z" />
  </Icon>
);
